import React from "react";
import Typography from "@material-ui/core/Typography";
import {Grid} from "@material-ui/core";
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
import TablaProductividadPorCliente from "../components/TablaProductividadPorCliente";
import TablaProductividadPorUsuario from "../components/TablaProductividadPorUsuario";

class ProductividadOperadores extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            openSnack: false,
            severity: null,
            message: null,
            theme : responsiveFontSizes(createMuiTheme())
        }
    }


    render() {
        return (
            <div>
                <Typography variant="h4" gutterBottom>Datos de Productividad</Typography>
                <Grid container spacing={2}>
                    {/*<Grid item xs={4} style={{maxWidth: 220}}>
                        <Card>
                            <CardContent>
                                <ThemeProvider theme={this.state.theme}>
                                    <Typography  style={{color:'#5c6bc0'}} variant="h5">N° Inventarios</Typography>
                                    <Typography style={{color:'#1a237e'}} variant="h1">123</Typography>
                                </ThemeProvider>
                            </CardContent>
                        </Card>
                    </Grid>*/}
                    <Grid item xs={12}>
                        <TablaProductividadPorCliente/>
                    </Grid>
                    <Grid item xs={12}>
                        <TablaProductividadPorUsuario/>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default ProductividadOperadores;